(function () {
  if (window.__elixirReviewsLoaded) return;
  window.__elixirReviewsLoaded = true;

  const sectionScript = (sectionId) => {
  const section = document.querySelector(
    '#shopify-section-' + sectionId
  );

  if (!section) return;

  const summaryImagesContainer = section.querySelector(
    '.cr-summary-right-content'
  );

  const reviews = section.querySelectorAll('.review-card');

  if (!summaryImagesContainer || !reviews.length) return;

  let popupComponent = null;
  let popupOverlay = null;
  let popupContentLeft;
  let popupContentRight;
  let imagesSlider = null;
  let imageSliderTrack;
  let displayReviewImages = [];
  let reviewsData = [];
  let reviewsNavigation = null;
  let navigationCount = null;
  let currentReviewIndex = null;
  let currentReviewClass = null;

  /* Positions in reviewsData that the popup can actually show. Reviews
     without images are skipped because the popup's left column is an image
     slider, so landing on one would leave it blank. */
  const navigableIndexes = [];

  const initReviewSlider = (container) => {
    const slider = container.querySelector('.review-images-slider');

    if (!slider || !imageSliderTrack) return;

    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    const getSlides = () => {
      return [...imageSliderTrack.querySelectorAll('.review-img')];
    };

    const updateSlider = () => {
      imageSliderTrack.style.transform = `translateX(-${currentIndex * 100}%)`;
    };

    const goNext = () => {
      const slides = getSlides();

      if (currentIndex < slides.length - 1) {
        currentIndex++;
    }

      updateSlider();
    };

    const goPrev = () => {
      if (currentIndex > 0) {
        currentIndex--;
      }

      updateSlider();
    };

    slider.addEventListener('pointerdown', (event) => {
      if (getSlides().length <= 1) return;

      isDragging = true;
      startX = event.clientX;
      currentX = startX;

      slider.classList.add('is-dragging');
      slider.setPointerCapture(event.pointerId);

      imageSliderTrack.style.transition = 'none';
    });

    slider.addEventListener('pointermove', (event) => {
      if (!isDragging) return;

      currentX = event.clientX;

      const difference = currentX - startX;
      let percentage = (difference / slider.offsetWidth) * 100;

      const slides = getSlides();
      const lastIndex = slides.length - 1;

      if (
        (currentIndex === 0 && difference > 0) ||
        (currentIndex === lastIndex && difference < 0)
      ) {
        percentage *= 0.25;
      }

      imageSliderTrack.style.transform = `
        translateX(calc(-${currentIndex * 100}% + ${percentage}%))
      `;
    });

    const endDrag = () => {
      if (!isDragging) return;

      isDragging = false;
      slider.classList.remove('is-dragging');

      imageSliderTrack.style.transition = 'transform 0.3s ease';

      const difference = currentX - startX;
      const threshold = slider.offsetWidth * 0.2;

      if (Math.abs(difference) > threshold) {
        if (difference < 0) {
          goNext();
        } else {
          goPrev();
        }
      } else {
        updateSlider();
      }
    };

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    return {
      reset() {
        currentIndex = 0;
        startX = 0;
        currentX = 0;
        isDragging = false;

        imageSliderTrack.style.transition = 'none';
        imageSliderTrack.style.transform = 'translateX(0%)';
      }
    };
  };

  const openPopup = () => {
    if(!popupComponent) return;

    popupComponent.classList.add('open');

    // Moves the keyboard into the popup, which is also what lets it receive
    // the arrow and escape keys handled below.
    popupComponent.focus({ preventScroll: true });
  }

  const closePopup = () => {
    if(!popupComponent) return;

    popupComponent.classList.remove('open');

    if (parseFloat(getComputedStyle(popupComponent).transitionDuration) === 0) {
      imagesSlider?.reset();
    }
  }

  const displayReview = (index) => {
    const reviewData = reviewsData[index];

    if(!reviewData) return;

    const { id, images, header, rating, content, footer } = reviewData;

    currentReviewIndex = index;

    if(imageSliderTrack && images.length > 0) {
      imageSliderTrack.innerHTML = '';

      images.forEach(image => {
        imageSliderTrack.appendChild(image.cloneNode(true))  
      });

      // Each review opens on its first image instead of inheriting the
      // slide position of the review we navigated away from.
      imagesSlider?.reset();
    }

    if(popupContentRight) {
      /* The block id class scopes that review's own styling, so the previous
         review's class has to come off or both rule sets apply at once. */
      if(currentReviewClass) popupContentRight.classList.remove(currentReviewClass);

      currentReviewClass = id;

      popupContentRight.classList.add(id);
      popupContentRight.innerHTML = '';

      if(header) popupContentRight.appendChild(header.cloneNode(true));
      if(rating) popupContentRight.appendChild(rating.cloneNode(true));
      if(content) popupContentRight.appendChild(content.cloneNode(true));
      if(footer) popupContentRight.appendChild(footer.cloneNode(true));
    }

    updateReviewsNavigation();

    openPopup();
  }

  const updateReviewsNavigation = () => {
    if(!reviewsNavigation) return;

    const position = navigableIndexes.indexOf(currentReviewIndex);

    if(position === -1) return;

    const prevButton = reviewsNavigation.querySelector('.nav-button.prev');
    const nextButton = reviewsNavigation.querySelector('.nav-button.next');

    if(prevButton) prevButton.disabled = position === 0;
    if(nextButton) nextButton.disabled = position === navigableIndexes.length - 1;

    if(navigationCount) {
      navigationCount.textContent = `${position + 1} / ${navigableIndexes.length}`;
    }
  };

  const goToAdjacentReview = (offset) => {
    const position = navigableIndexes.indexOf(currentReviewIndex);

    if(position === -1) return;

    const targetIndex = navigableIndexes[position + offset];

    if(targetIndex === undefined) return;

    displayReview(targetIndex);
  };

  const initPopupComponent = () => {
    const existingPopup = document.querySelector(
      '.reviews-content-popup[data-section-id="' + sectionId + '"]'
    );

    if (existingPopup) {
      existingPopup.remove();
    }

    popupComponent = document.createElement('div');
    popupComponent.classList.add('block-' + sectionId, 'reviews-content-popup');
    popupComponent.dataset.sectionId = sectionId;
    popupComponent.tabIndex = -1;

    popupOverlay = document.createElement('div');
    popupOverlay.classList.add('bg-overlay');

    const popupContainer = document.createElement('div');
    popupContainer.classList.add('popup-content-container');

    popupContentLeft = document.createElement('div');
    popupContentLeft.classList.add('popup-content-left');

    const imageSlider = document.createElement('div');
    imageSlider.classList.add('review-images-slider');

    imageSliderTrack = document.createElement('div');
    imageSliderTrack.classList.add('review-images-track');

    imageSlider.appendChild(imageSliderTrack);

    popupContentLeft.appendChild(imageSlider);

    popupContentRight = document.createElement('div');
    popupContentRight.classList.add('popup-content-right');

    popupContainer.appendChild(popupContentLeft);
    popupContainer.appendChild(popupContentRight);

    /* Rendered in the section markup so the arrows come from the shared nav
       button snippet; moved in here, and only kept when there is more than
       one review to move between. */
    reviewsNavigation = section.querySelector('[data-popup-navigation]');

    if(reviewsNavigation && navigableIndexes.length > 1) {
      reviewsNavigation.hidden = false;
      navigationCount = reviewsNavigation.querySelector('[data-popup-navigation-count]');

      reviewsNavigation
        .querySelector('.nav-button.prev')
        ?.addEventListener('click', () => goToAdjacentReview(-1));

      reviewsNavigation
        .querySelector('.nav-button.next')
        ?.addEventListener('click', () => goToAdjacentReview(1));

      popupContainer.appendChild(reviewsNavigation);
    } else {
      // Left hidden in the section markup rather than removed, so a later
      // run still has a node to pick up.
      reviewsNavigation = null;
    }

    popupComponent.appendChild(popupOverlay);
    popupComponent.appendChild(popupContainer);

    /* Bound to the popup rather than the document so the listener goes away
       with it when the theme editor reloads the section. */
    popupComponent.addEventListener('keydown', (event) => {
      if(event.key === 'Escape') {
        closePopup();
      } else if(event.key === 'ArrowLeft') {
        goToAdjacentReview(-1);
      } else if(event.key === 'ArrowRight') {
        goToAdjacentReview(1);
      } else {
        return;
      }

      event.preventDefault();
    });

    popupComponent.addEventListener('transitionend', (event) => {
      if(event.target !== popupComponent || event.propertyName !== 'opacity') return;
      if(popupComponent.classList.contains('open')) return;

      imagesSlider?.reset();
    });

    document.body.appendChild(popupComponent);
  };

  const initReviews = () => {
    displayReviewImages = [];

    reviews.forEach((review, reviewIndex) => {
      let summaryImage = null;

      const reviewId = `block-${review.dataset.blockId}`;
      const reviewImages = review.querySelectorAll(
        '.review-images img'
      );
      const reviewHeader = review.querySelector('.review-header');
      const reviewStars = review.querySelector('.review-stars');
      const reviewContent = review.querySelector('.review-content');
      const reviewFooter = review.querySelector('.review-footer');

      if(reviewImages.length > 0) {
        navigableIndexes.push(reviewIndex);

        summaryImage = reviewImages[0].cloneNode(true);

        summaryImage.dataset.index = reviewIndex;

        displayReviewImages.push(summaryImage);

        reviewImages.forEach((image) => {
          image.dataset.index = reviewIndex;

          image.addEventListener('click', () => displayReview(reviewIndex));
        });
      }

      reviewsData.push({
        id: reviewId,
        images: reviewImages,
        header: reviewHeader,
        rating: reviewStars,
        content: reviewContent,
        footer: reviewFooter
      });

      if(summaryImage) {
        summaryImage.addEventListener('click', () => {
          displayReview(reviewIndex);
        });
      }
    });
  };

  initReviews();

  summaryImagesContainer.innerHTML = '';

  displayReviewImages.forEach((image) => {
    summaryImagesContainer.appendChild(image);
  });

  initPopupComponent();
  imagesSlider = initReviewSlider(popupComponent);

  if(popupOverlay) {
    popupOverlay.addEventListener('click', () => closePopup());
  }
  };

  const sectionFilters = (sectionId) => {
  const root = document.querySelector('#shopify-section-' + sectionId);

  if (!root || root.dataset.reviewFiltersReady === 'true') return;

  const list = root.querySelector('.cr-reviews-list');

  if (!list) return;

  const cards = Array.from(list.querySelectorAll('.review-card'));

  if (!cards.length) return;

  // Shopify wraps each block in a .shopify-block, so hiding and reordering
  // have to act on that wrapper or the flex gap is left behind.
  const entries = cards.map((card, index) => ({
    item: card.closest('.shopify-block') || card,
    index,
    rating: parseFloat(card.dataset.reviewRating) || 0,
    topics: card.dataset.reviewTopics || '|'
  }));

  const sortSelect = root.querySelector('[data-review-sort]');
  const filterContainer = root.querySelector('[data-review-topic-filters]');

  // Collect the topics off the cards, in first-seen order, counting as we go.
  const buildTopicFilters = () => {
    if (!filterContainer) return;

    const counts = new Map();

    cards.forEach((card) => {
      const slugs = (card.dataset.reviewTopics || '')
        .split('|')
        .filter(Boolean);
      const labels = (card.dataset.reviewTopicLabels || '')
        .split('~~')
        .filter(Boolean);

      slugs.forEach((slug, position) => {
        const existing = counts.get(slug);

        if (existing) {
          existing.count += 1;
        } else {
          counts.set(slug, { label: labels[position] || slug, count: 1 });
        }
      });
    });

    if (!counts.size) return;

    const pill = (slug, label, count, isActive) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = isActive ? 'cr-topic is-active' : 'cr-topic';
      button.dataset.reviewFilter = slug;
      button.setAttribute('aria-pressed', String(isActive));
      button.append(label);

      const badge = document.createElement('span');

      badge.className = 'cr-topic__count';
      badge.textContent = String(count);
      button.append(badge);

      return button;
    };

    filterContainer.append(
      pill('all', filterContainer.dataset.allLabel || 'All', cards.length, true)
    );

    counts.forEach((entry, slug) => {
      filterContainer.append(pill(slug, entry.label, entry.count, false));
    });

    filterContainer.hidden = false;
  };

  buildTopicFilters();

  const filterButtons = Array.from(root.querySelectorAll('[data-review-filter]'));

  let activeFilter = 'all';

  const render = () => {
    entries.forEach((entry) => {
      const matches =
        activeFilter === 'all' || entry.topics.includes(`|${activeFilter}|`);

      entry.item.hidden = !matches;
    });

    filterButtons.forEach((button) => {
      const isActive = button.dataset.reviewFilter === activeFilter;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    // Reorder through the flex order property instead of moving nodes, so
    // the image popup keeps the element references it captured on load.
    const mode = sortSelect ? sortSelect.value : 'featured';
    const sorted = entries.slice();

    if (mode === 'highest') {
      sorted.sort((a, b) => b.rating - a.rating || a.index - b.index);
    } else if (mode === 'lowest') {
      sorted.sort((a, b) => a.rating - b.rating || a.index - b.index);
    }

    sorted.forEach((entry, position) => {
      entry.item.style.order = position;
    });
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.reviewFilter;
      render();
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', render);
  }

  root.dataset.reviewFiltersReady = 'true';

  render();
  };

  const initAll = () => {
    document.querySelectorAll('.elixir-customer-reviews[data-section-id]').forEach((el) => {
      sectionScript(el.dataset.sectionId);
      sectionFilters(el.dataset.sectionId);
    });
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
